import InternalChat from './Index.vue';

export const routes = [
  {
    path: 'internal-chat',
    name: 'internal_chat',
    component: InternalChat,
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
  },
];
